import { defineRouting } from "next-intl/routing";
import { hasLocale } from "next-intl";

export const routing = defineRouting({
  locales: ["en", "es"],
  defaultLocale: "en",
  localePrefix: "as-needed",
});

// TODO Should be a type guard?
export function isAllowedLocale(locale?: string) {
  return hasLocale(routing.locales, locale);
}
